export default __webpack_public_path__ + "static/media/banner6.db6b40cf.jpg";